<button
    class="button"
    [ngClass]="[buttonClass, showLabel ? '' : 'icon-only']"
    [disabled]="disabled"
    (click)="handleClick($event)"
>
    <ng-container *ngIf="showIcon">
        <mat-icon class="button-icon">{{ icon }}</mat-icon>
    </ng-container>
    <ng-container *ngIf="showLabel">
        <span class="button-label">{{ label }}</span>
    </ng-container>
    <ng-container *ngIf="showCount && count !== undefined">
        <span class="button-count">({{ count }})</span>
    </ng-container>
    <ng-container *ngIf="showDisclosure">
        <mat-icon class="button-disclosure">expand_more</mat-icon>
    </ng-container>
</button>
